module.exports = __webpack_public_path__ + "img/contract.665e1931.svg";